import { usePlayer } from '@/api/queries';
import { useAuthStore } from '@/store/authStore';
import { PlayerHeader } from '@/components/player/PlayerHeader';
import { WorldMap } from '@/components/world-map/WorldMap';

export function MainScreen() {
  const userId = useAuthStore((s) => s.userId);
  const { data, isLoading } = usePlayer(userId);
  const player = data?.player;

  return (
    <div className="relative flex-1 flex flex-col">
      {player && <PlayerHeader player={player} />}
      <div className="absolute inset-0">
        <WorldMap className="pt-[80px]" />
      </div>
      {!player && isLoading && (
        <div className="absolute inset-0 flex items-center justify-center text-white/60">
          Загружаем профиль…
        </div>
      )}
    </div>
  );
}
